import React from 'react';
import * as moment from 'moment';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { Typography } from '@material-ui/core';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import ThumbUpOutlinedIcon from '@material-ui/icons/ThumbUpOutlined';
import ChatBubbleOutlineIcon from '@material-ui/icons/ChatBubbleOutline';
import Col from 'components/Col';
import Row from 'components/Row';
import color from 'config/color';
import Modal from 'components/Modal';
import Avatar from 'components/Avatar';
import Card from 'components/Card/Card';
import { useModal } from 'components/Modal';
import { useActions } from 'helpers/useActions';
import { likePostAction } from '../actions';
import LoginAlertModal from 'components/loginModal/LoginAlertModal';
import { AvatarName } from '../styled';

export default function ForumPostCard({ post, push, anon, onEdit, history }) {
  const likePost = useActions(likePostAction);
  const uid = useSelector(state => state.authState.firestoreUser.uid);
  const authUser = useSelector(state => state.authState.firestoreUser);

  const modal = useModal();

  let liked = false;
  if (post) {
    if (post.upVotes) {
      liked = post.upVotes.includes(uid);
    }
  }

  function isLiked() {
    if (liked) {
      return 'bolder';
    }
  }

  const Icon = () => {
    if (liked === true) {
      return <ThumbIcon />;
    }
    return <ThumbOutlinedIcon />;
  };

  const checkLoggedIn = () => {
    if (authUser.anon) {
      modal.open();
    } else {
      likePost(post, uid);
    }
  };

  const handleOnClick = () => {
    modal.close();
  };

  return (
    <ForumCard style={{ cursor: 'pointer' }} padding="0">
      <div>
        {/* <Col> */}
        <Row justify="space-between" marginbottom="0px">
          <Row justify="flex-start">
            <Col
              padding="1.5em"
              width="100%"
              style={{ flexGrow: 1, paddingBottom: 0 }}
            >
              <Col padding="0" onClick={() => push()}>
                <Row
                  width="100%"
                  justify="space-between"
                  marginbottom="0"
                  flexDirection="column-reverse"
                >
                  <Row justify="flex-start">
                    <Col padding="0">
                      <Avatar style={{ marginTop: 0 }} image={post.imageURL} />
                    </Col>
                    <Col padding="0" justify="center">
                      <Col padding="0">
                        <AvatarName variant="h6">{post.name}</AvatarName>
                        <Typography variant="body2" style={{ fontSize: 14 }}>
                          {moment(post.date).fromNow()}
                        </Typography>
                      </Col>
                    </Col>
                  </Row>
                  <div style={{ display: 'flex' }}>
                    {post.subject ? (
                      <CategoryInCard>{post.subject}</CategoryInCard>
                    ) : (
                      <div></div>
                    )}
                  </div>
                </Row>
                <div style={{ marginTop: 5, overflowWrap: 'break-word' }}>
                  <Typography
                    style={{
                      color: color.grey,
                      margin: '0',
                      whiteSpace: 'pre-wrap'
                    }}
                  >
                    {post.message}
                  </Typography>
                </div>
              </Col>
              <Col
                width="auto"
                marginbottom="0"
                align="flex-end"
                padding="0"
                style={{ cursor: 'pointer', paddingleft: 20, marginTop: 7 }}
              >
                <Row>
                  <Count
                    color="primary"
                    disabled={anon}
                    onClick={() => checkLoggedIn()}
                    fontWeight={isLiked()}
                  >
                    <Icon />
                    <span style={{ paddingLeft: 7, display: 'flex' }}>
                      <Text>
                        {(post.upVotes && post.upVotes.length) || '0'}
                      </Text>
                      <Text>likes</Text>
                    </span>
                  </Count>

                  <div>|</div>
                  <Count
                    paddingleft="20"
                    color="primary"
                    disabled={anon}
                    onClick={() => push()}
                  >
                    <ChatBubbleOutlineIcon style={{ fontSize: '1rem' }} />
                    <span style={{ paddingLeft: '7px', display: 'flex' }}>
                      <Text>{post.commentCount}</Text>
                      <Text>comments</Text>
                    </span>
                  </Count>
                </Row>
              </Col>
            </Col>
          </Row>
        </Row>
      </div>
      <Modal {...modal.props}>
        <React.Fragment>
          <LoginAlertModal history={history} onClick={handleOnClick} />
        </React.Fragment>
      </Modal>
    </ForumCard>
  );
}

const Count = styled(Typography).attrs({
  variant: 'h6'
})`
  && {
    display: flex;
    align-items: center;
    text-decoration: none;
    text-align: right;
    margin-right: 16px;
    color: #3c8592;
    font-weight: ${props => props.fontWeight};
    padding-left: ${props => props.paddingleft || 0}px;
  }
`;

const ForumCard = styled(Card)`
  && {
    overflow: auto;
    border-radius: 20px;
    @media (max-width: 1200px) {
      width: auto;
    }
  }
`;

const ThumbIcon = styled(ThumbUpIcon)`
  && {
    font-size: 1rem;
  }
`;

const ThumbOutlinedIcon = styled(ThumbUpOutlinedIcon)`
  && {
    font-size: 1rem;
  }
`;

const Views = styled(Typography)`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const CategoryInCard = styled.h5`
  background-color: ${color.medilinkColor};
  height: 2em;
  color: white;
  border-radius: 5px;
  display: flex;
  align-items: center;
  padding: 1em;
`;

const Text = styled(Typography)`
  && {
    display: flex;
    align-items: center;
    font-size: 15px;
    margin-left: 4px;
    @media (max-width: 960px) {
      display: none;
    }
  }
`;
